// src/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth';
import accountManagementReducer from './accountManagement';
import productsReducer from './products/slice'; 
import workflowsReducer from './workflows/slice';
import productFormsReducer from './productsForm/slice'; 
import ticketingReducer from './ticketing/slice'; 
import customerReducer from './customer'; 
import productsSubitemsReducer from './productsSubitems/slice';
import payInvoiceReducer from './payInvoice/slice'; 
import docsVerificationReducer from './docsVerification/slice'; 


export const store = configureStore({
  reducer: {
    auth: authReducer,
    accountManagement: accountManagementReducer,
    products: productsReducer,
    productForms: productFormsReducer,
    productsSubitems: productsSubitemsReducer,
    workflows: workflowsReducer,
    ticketing: ticketingReducer, 
    customer: customerReducer,
    payInvoice: payInvoiceReducer, 
    docsVerification: docsVerificationReducer,
  },
});

// Inferred types for TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

